import React, { useEffect, useState } from "react";

const CountdownTimer = ({ initialTime }) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);

  useEffect(() => {
    // شروع تایمر بلافاصله پس از باز شدن صفحه
    if (timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer); // پاک‌سازی تایمر
    }
  }, [timeLeft]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (time % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  return (
    <div className="countdwn-div">
      <span>دریافت مجدد کد پس از </span>
      <span id="countdown">{formatTime(timeLeft)}</span>
      <span> دقیقه</span>
    </div>
  );
};

export default CountdownTimer;
